// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__31x60","select":"Header_select__KlNXl","clinic":"Header_clinic__2rO2R"};